import { createLazyReactDirective } from '../../shell/ng';

export default createLazyReactDirective(
  async () => (await import('./MyProfileLink')).MyProfileLink,
  'myProfileLink',
);
